<template>
  <div class="selected-tags">
    <div class="tagsarea-input tags-tabs q-mb-xl q-mt-xl">
      <div class="row">
        <q-space />
        <q-btn
          label="Edit tags"
          class="orange-btn bold-font q-mb-sm"
          @click="enableShowSelectTags"
          no-caps
          dense
        >
        </q-btn>
      </div>
      <q-card>
        <q-tabs
          v-model="tab"
          dense
          class="text-grey"
          active-color="primary"
          indicator-color="primary"
          align="justify"
          narrow-indicator
        >
          <q-tab name="audiences" label="Audiences">
            <q-badge color="#0a1f8f" class="tag-badge" floating>{{
              propsSelectedAudience.length
            }}</q-badge>
          </q-tab>
          <q-tab name="purposes" label="Purposes">
            <q-badge color="#0a1f8f" class="tag-badge" floating>{{
              propsSelectedPurposes.length
            }}</q-badge>
          </q-tab>
          <q-tab name="locations" label="Locations">
            <q-badge color="#0a1f8f" class="tag-badge" floating>{{
              propsSelectedLocations.length
            }}</q-badge>
          </q-tab>
          <q-tab name="schemetype" label="Scheme type">
            <q-badge color="#0a1f8f" class="tag-badge" floating>{{
              propsSelectedSchemeTypes.length
            }}</q-badge>
          </q-tab>
          <q-tab name="keywords" label="Keywords">
            <q-badge color="#0a1f8f" class="tag-badge" floating>{{
              propsSelectedKeywords.length
            }}</q-badge>
          </q-tab>
          <q-tab name="industriesnew" label="Industries NEW">
            <q-badge color="#0a1f8f" class="tag-badge" floating>{{
              propsSelectedIndustriesNew.length
            }}</q-badge>
          </q-tab>
          <q-tab name="projecttype" label="Project type">
            <q-badge color="#0a1f8f" class="tag-badge" floating>{{
              propsSelectedProjectTypes.length
            }}</q-badge>
          </q-tab>
        </q-tabs>
        <q-separator />

        <q-tab-panels v-model="tab" animated>
          <q-tab-panel name="audiences">
            <div
              class="row"
              v-if="
                selectedTagsAudience.length === 0 &&
                  excludedTagsAudience.length === 0
              "
            >
              <q-icon
                name="las la-exclamation-triangle"
                color="black"
                style="font-size: 1.5em;"
              ></q-icon>
              <span>No tags selected</span>
            </div>
            <div
              class="row"
              v-if="
                selectedTagsAudience.length > 0 ||
                  excludedTagsAudience.length > 0
              "
            >
              <div class="col-md-6">
                <q-list>
                  <q-item v-for="tag in selectedTagsAudience" :key="tag.id">
                    <q-icon
                      name="las la-check"
                      color="green"
                      style="font-size: 1.5em;"
                    ></q-icon>
                    <span>{{ tag.label }}</span>
                    <span v-if="tag.parentName">
                      &nbsp;({{ tag.parentName }})</span
                    >
                  </q-item>
                </q-list>
              </div>
              <div class="col-md-6">
                <q-list>
                  <q-item v-for="tag in excludedTagsAudience" :key="tag.id">
                    <q-icon
                      name="las la-times"
                      color="red"
                      style="font-size: 1.5em;"
                    ></q-icon>
                    <span>{{ tag.label }}</span>
                    <span v-if="tag.parentName">
                      &nbsp;({{ tag.parentName }})</span
                    >
                  </q-item>
                </q-list>
              </div>
            </div>
          </q-tab-panel>
          <q-tab-panel name="purposes">
            <div
              class="row"
              v-if="
                selectedTagsPurposes.length === 0 &&
                  excludedTagsPurposes.length === 0
              "
            >
              <q-icon
                name="las la-exclamation-triangle"
                color="black"
                style="font-size: 1.5em;"
              ></q-icon>
              <span>No tags selected</span>
            </div>
            <div
              class="row"
              v-if="
                selectedTagsPurposes.length > 0 ||
                  excludedTagsPurposes.length > 0
              "
            >
              <div class="col-md-6">
                <q-list>
                  <q-item v-for="tag in selectedTagsPurposes" :key="tag.id">
                    <q-icon
                      name="las la-check"
                      color="green"
                      style="font-size: 1.5em;"
                    ></q-icon>
                    <span>{{ tag.label }}</span>
                    <span v-if="tag.parentName">
                      &nbsp;({{ tag.parentName }})</span
                    >
                  </q-item>
                </q-list>
              </div>
              <div class="col-md-6">
                <q-list>
                  <q-item v-for="tag in excludedTagsPurposes" :key="tag.id">
                    <q-icon
                      name="las la-times"
                      color="red"
                      style="font-size: 1.5em;"
                    ></q-icon>
                    <span>{{ tag.label }}</span>
                    <span v-if="tag.parentName">
                      &nbsp;({{ tag.parentName }})</span
                    >
                  </q-item>
                </q-list>
              </div>
            </div>
          </q-tab-panel>
          <q-tab-panel name="locations">
            <div
              class="row"
              v-if="
                selectedTagsLocations.length === 0 &&
                  excludedTagsLocations.length === 0
              "
            >
              <q-icon
                name="las la-exclamation-triangle"
                color="black"
                style="font-size: 1.5em;"
              ></q-icon>
              <span>No tags selected</span>
            </div>
            <div
              class="row"
              v-if="
                selectedTagsLocations.length > 0 ||
                  excludedTagsLocations.length > 0
              "
            >
              <div class="col-md-6">
                <q-list>
                  <q-item v-for="tag in selectedTagsLocations" :key="tag.id">
                    <q-icon
                      name="las la-check"
                      color="green"
                      style="font-size: 1.5em;"
                    ></q-icon>
                    <span>{{ tag.label }}</span>
                    <span v-if="tag.parentName">
                      &nbsp;({{ tag.parentName }})</span
                    >
                  </q-item>
                </q-list>
              </div>
              <div class="col-md-6">
                <q-list>
                  <q-item v-for="tag in excludedTagsLocations" :key="tag.id">
                    <q-icon
                      name="las la-times"
                      color="red"
                      style="font-size: 1.5em;"
                    ></q-icon>
                    <span>{{ tag.label }}</span>
                    <span v-if="tag.parentName">
                      &nbsp;({{ tag.parentName }})</span
                    >
                  </q-item>
                </q-list>
              </div>
            </div>
          </q-tab-panel>
          <q-tab-panel name="schemetype">
            <div
              class="row"
              v-if="
                selectedTagsSchemeTypes.length === 0 &&
                  excludedTagsSchemeTypes.length === 0
              "
            >
              <q-icon
                name="las la-exclamation-triangle"
                color="black"
                style="font-size: 1.5em;"
              ></q-icon>
              <span>No tags selected</span>
            </div>
            <div
              class="row"
              v-if="
                selectedTagsSchemeTypes.length > 0 ||
                  excludedTagsSchemeTypes.length > 0
              "
            >
              <div class="col-md-6">
                <q-list>
                  <q-item v-for="tag in selectedTagsSchemeTypes" :key="tag.id">
                    <q-icon
                      name="las la-check"
                      color="green"
                      style="font-size: 1.5em;"
                    ></q-icon>
                    <span>{{ tag.label }}</span>
                    <span v-if="tag.parentName">
                      &nbsp;({{ tag.parentName }})</span
                    >
                  </q-item>
                </q-list>
              </div>
              <div class="col-md-6">
                <q-list>
                  <q-item v-for="tag in excludedTagsSchemeTypes" :key="tag.id">
                    <q-icon
                      name="las la-times"
                      color="red"
                      style="font-size: 1.5em;"
                    ></q-icon>
                    <span>{{ tag.label }}</span>
                    <span v-if="tag.parentName">
                      &nbsp;({{ tag.parentName }})</span
                    >
                  </q-item>
                </q-list>
              </div>
            </div>
          </q-tab-panel>
          <q-tab-panel name="keywords">
            <div style="min-width: 250px" class="tag-selector">
              <q-select
                outlined
                bg-color="white"
                v-model="props"
                multiple
                input-debounce="0"
                :options="propsSelectedKeywords"
                option-value="name"
                class="scheme-inputs"
                option-label="name"
                use-input
                use-chips
                stack-label
                label="Select or input keywords"
                @new-value="createValue"
                @filter="filterFn"
              />
            </div>
          </q-tab-panel>
          <q-tab-panel name="industriesnew">
            <div
              class="row"
              v-if="
                selectedTagsIndustriesNew.length === 0 &&
                  excludedTagsIndustriesNew.length === 0
              "
            >
              <q-icon
                name="las la-exclamation-triangle"
                color="black"
                style="font-size: 1.5em;"
              ></q-icon>
              <span>No tags selected</span>
            </div>
            <div
              class="row"
              v-if="
                selectedTagsIndustriesNew.length > 0 ||
                  excludedTagsIndustriesNew.length > 0
              "
            >
              <div class="col-md-6">
                <q-list>
                  <q-item
                    v-for="tag in selectedTagsIndustriesNew"
                    :key="tag.id"
                  >
                    <q-icon
                      name="las la-check"
                      color="green"
                      style="font-size: 1.5em;"
                    ></q-icon>
                    <span>{{ tag.label }}</span>
                    <span v-if="tag.parentName">
                      &nbsp;({{ tag.parentName }})</span
                    >
                  </q-item>
                </q-list>
              </div>
              <div class="col-md-6">
                <q-list>
                  <q-item
                    v-for="tag in excludedTagsIndustriesNew"
                    :key="tag.id"
                  >
                    <q-icon
                      name="las la-times"
                      color="red"
                      style="font-size: 1.5em;"
                    ></q-icon>
                    <span>{{ tag.label }}</span>
                    <span v-if="tag.parentName">
                      &nbsp;({{ tag.parentName }})</span
                    >
                  </q-item>
                </q-list>
              </div>
            </div>
          </q-tab-panel>
          <q-tab-panel name="projecttype">
            <div
              class="row"
              v-if="
                selectedTagsProjectTypes.length === 0 &&
                  excludedTagsProjectTypes.length === 0
              "
            >
              <q-icon
                name="las la-exclamation-triangle"
                color="black"
                style="font-size: 1.5em;"
              ></q-icon>
              <span>No tags selected</span>
            </div>
            <div
              class="row"
              v-if="
                selectedTagsProjectTypes.length > 0 ||
                  excludedTagsProjectTypes.length > 0
              "
            >
              <div class="col-md-6">
                <q-list>
                  <q-item v-for="tag in selectedTagsProjectTypes" :key="tag.id">
                    <q-icon
                      name="las la-check"
                      color="green"
                      style="font-size: 1.5em;"
                    ></q-icon>
                    <span>{{ tag.label }}</span>
                    <span v-if="tag.parentName">
                      &nbsp;({{ tag.parentName }})</span
                    >
                  </q-item>
                </q-list>
              </div>
              <div class="col-md-6">
                <q-list>
                  <q-item v-for="tag in excludedTagsProjectTypes" :key="tag.id">
                    <q-icon
                      name="las la-times"
                      color="red"
                      style="font-size: 1.5em;"
                    ></q-icon>
                    <span>{{ tag.label }}</span>
                    <span v-if="tag.parentName">
                      &nbsp;({{ tag.parentName }})</span
                    >
                  </q-item>
                </q-list>
              </div>
            </div>
          </q-tab-panel>
        </q-tab-panels>
      </q-card>
    </div>
  </div>
  <SelectTags
    v-if="showSelectTags"
    v-model:audiencePairs="propsSelectedAudience"
    v-model:purposesPairs="propsSelectedPurposes"
    v-model:locationsPairs="propsSelectedLocations"
    v-model:schemeTypesPairs="propsSelectedSchemeTypes"
    v-model:projectTypesPairs="propsSelectedProjectTypes"
    v-model:industriesNewPairs="propsSelectedIndustriesNew"
    v-model:selectedGroups="propsSelectedGroups"
    :showSelectTags="showSelectTags"
    :audienceNodes="audienceNodes"
    :purposesNodes="purposesNodes"
    :industriesNewNodes="industriesNewNodes"
    :locationsNodes="locationsNodes"
    :schemeTypesNodes="schemeTypesNodes"
    :projectTypesNodes="projectTypesNodes"
    :isEdit="false"
  />
</template>

<script>
import store from "../../store/index";
import { computed, onMounted, ref, watch } from "vue";
import TagsService from "../../services/tags.service";
import SelectTags from "./SelectTags.vue";
import ETagType from "../../enums/ETagType";

export default {
  name: "SelectedTagsCreateScheme",
  components: {
    SelectTags
  },
  props: {
    selectedAudience: Array,
    selectedPurposes: Array,
    selectedLocations: Array,
    selectedIndustriesNew: Array,
    selectedSchemeTypes: Array,
    selectedProjectTypes: Array,
    selectedKeywords: Array,
    selectedGroups: Array
  },
  emits: [
    "update:selectedAudience",
    "update:selectedPurposes",
    "update:selectedLocations",
    "update:selectedSchemeTypes",
    "update:selectedIndustriesNew",
    "update:selectedProjectTypes",
    "update:selectedKeywords",
    "update:selectedGroups"
  ],
  setup(props, { emit }) {
    const propsSelectedAudience = computed({
      get: () => props.selectedAudience,
      set: val => emit("update:selectedAudience", val)
    });

    const propsSelectedPurposes = computed({
      get: () => props.selectedPurposes,
      set: val => emit("update:selectedPurposes", val)
    });

    const propsSelectedLocations = computed({
      get: () => props.selectedLocations,
      set: val => emit("update:selectedLocations", val)
    });

    const propsSelectedSchemeTypes = computed({
      get: () => props.selectedSchemeTypes,
      set: val => emit("update:selectedSchemeTypes", val)
    });

    const propsSelectedProjectTypes = computed({
      get: () => props.selectedProjectTypes,
      set: val => emit("update:selectedProjectTypes", val)
    });

    const propsSelectedIndustriesNew = computed({
      get: () => props.selectedIndustriesNew,
      set: val => emit("update:selectedIndustriesNew", val)
    });

    const propsSelectedKeywords = computed({
      get: () => props.selectedKeywords,
      set: val => emit("update:selectedKeywords", val)
    });

    const propsSelectedGroups = computed({
      get: () => props.selectedGroups,
      set: val => emit("update:selectedGroups", val)
    });

    const tab = ref("audiences");

    onMounted(async () => {
      await TagsService.getTagTypeTree("Audience", ETagType.Audience);
      await TagsService.getTagTypeTree("Purposes", ETagType.Purposes);
      await TagsService.getTagTypeTree("Locations", ETagType.Locations);
      await TagsService.getTagTypeTree("Scheme type", ETagType.SchemeType);
      await TagsService.getTagTypeTree("Project type", ETagType.ProjectType);
      await TagsService.getTagTypeTree(
        "Industries NEW",
        ETagType.IndustriesNew
      );
      await TagsService.getTagsByType("Keywords", ETagType.Keywords);
    });

    const enableShowSelectTags = () => {
      store.commit("scheme/enableShowSelectTags");
    };

    const showSelectTags = computed({
      get: () => store.state.scheme.showSelectTags
    });

    const allKeywordsTags = computed({
      get: () => store.state.tagsNavigation.keywordsTags
    });

    const filterOptions = ref(allKeywordsTags.value);

    const audienceNodes = computed({
      get: () => store.state.scheme.audienceTags
    });

    const locationsNodes = computed({
      get: () => store.state.scheme.locationsTags
    });

    const purposesNodes = computed({
      get: () => store.state.scheme.purposesTags
    });

    const schemeTypesNodes = computed({
      get: () => store.state.scheme.schemeTypesTags
    });

    const projectTypesNodes = computed({
      get: () => store.state.scheme.projectTypesTags
    });

    const industriesNewNodes = computed({
      get: () => store.state.scheme.industriesNewTags
    });

    const excludedTagsAudience = ref([]);
    const selectedTagsAudience = ref([]);
    const excludedTagsPurposes = ref([]);
    const selectedTagsPurposes = ref([]);
    const excludedTagsLocations = ref([]);
    const selectedTagsLocations = ref([]);
    const excludedTagsSchemeTypes = ref([]);
    const selectedTagsSchemeTypes = ref([]);
    const excludedTagsProjectTypes = ref([]);
    const selectedTagsProjectTypes = ref([]);
    const excludedTagsIndustriesNew = ref([]);
    const selectedTagsIndustriesNew = ref([]);

    const getRootNodes = filters =>
      filters.options.filter(
        element => !element.children || element.children.length === 0
      );

    const getFirstLevelNodes = filters =>
      filters.options.filter(
        element => element.children !== null && element.children.length > 0
      );

    const getChildNodes = filters =>
      filters
        .map(n =>
          n.children.filter(
            element => element.children !== null && element.children.length > 0
          )
        )
        .filter(el => el.length > 0)
        .flat();

    const setFirstLevelSelectedNodes = (
      firstLevelselectedNodes,
      selectedProps,
      selectedNodes,
      excludedNodes
    ) => {
      for (const node of firstLevelselectedNodes) {
        const { children, label } = node;
        let selectedChildren = children.filter(child =>
          selectedProps.some(selectedNode => child.id === selectedNode.id)
        );

        if (selectedChildren.length === children.length) {
          selectedNodes.push(node);
        } else if (
          children.length !== 1 &&
          selectedChildren.length === children.length - 1
        ) {
          selectedNodes.push(node);
          let excludedTag = children.filter(
            child =>
              !selectedChildren.some(
                selectedChild => child.id === selectedChild.id
              )
          );
          excludedTag[0].parentName = label;
          excludedNodes.push(excludedTag[0]);
        } else {
          selectedChildren.forEach(
            selectedChild => (selectedChild.parentName = label)
          );
          selectedNodes.push(...selectedChildren);
        }
      }
    };

    const setSelectedNodes = (
      selectedNodes,
      selectedProps,
      nodes,
      overviewSelectedNodes,
      overviewExcludedNodes
    ) => {
      for (const node of selectedNodes) {
        const { children, label } = node;
        let selectedChildren = children.filter(child =>
          selectedProps.some(selectedNode => child.id === selectedNode.id)
        );

        if (
          children.length !== 1 &&
          selectedChildren.length === children.length - 1
        ) {
          var parentOfSecondLevelParent = nodes.options.find(tag =>
            tag.children.includes(node)
          );
          node.parentName = parentOfSecondLevelParent.label;
          overviewSelectedNodes.push(node);
          let excludedTag = children.filter(
            child =>
              !selectedChildren.some(
                selectedNode => child.id === selectedNode.id
              )
          );
          excludedTag[0].parentName = label;
          overviewExcludedNodes.push(excludedTag[0]);
        } else if (selectedChildren.length !== children.length) {
          selectedChildren.forEach(
            selectedChild => (selectedChild.parentName = label)
          );
          overviewSelectedNodes.push(...selectedChildren);
        }
      }
    };

    watch(
      propsSelectedAudience,
      () => {
        selectedTagsAudience.value = [];
        excludedTagsAudience.value = [];
        var rootNodes = getRootNodes(audienceNodes.value);
        var firstLevelNodes = getFirstLevelNodes(audienceNodes.value);
        var secondLevelNodes = getChildNodes(firstLevelNodes);
        var thirdLevelNodes = getChildNodes(secondLevelNodes);
        var selectedRootTags = rootNodes.filter(({ id: id1 }) =>
          propsSelectedAudience.value.some(({ id: id2 }) => id2 === id1)
        );
        selectedTagsAudience.value.push(...selectedRootTags);

        setFirstLevelSelectedNodes(
          firstLevelNodes,
          propsSelectedAudience.value,
          selectedTagsAudience.value,
          excludedTagsAudience.value
        );

        setSelectedNodes(
          secondLevelNodes,
          propsSelectedAudience.value,
          audienceNodes.value,
          selectedTagsAudience.value,
          excludedTagsAudience.value
        );

        setSelectedNodes(
          thirdLevelNodes,
          propsSelectedAudience.value,
          audienceNodes.value,
          selectedTagsAudience.value,
          excludedTagsAudience.value
        );
      },
      { immediate: true, deep: true }
    );

    watch(
      propsSelectedPurposes,
      () => {
        selectedTagsPurposes.value = [];
        excludedTagsPurposes.value = [];
        var rootNodes = getRootNodes(purposesNodes.value);
        var firstLevelNodes = getFirstLevelNodes(purposesNodes.value);
        var secondLevelNodes = getChildNodes(firstLevelNodes);
        var thirdLevelNodes = getChildNodes(secondLevelNodes);
        var selectedRootTags = rootNodes.filter(({ id: id1 }) =>
          propsSelectedPurposes.value.some(({ id: id2 }) => id2 === id1)
        );

        selectedTagsPurposes.value.push(...selectedRootTags);

        setFirstLevelSelectedNodes(
          firstLevelNodes,
          propsSelectedPurposes.value,
          selectedTagsPurposes.value,
          excludedTagsPurposes.value
        );

        setSelectedNodes(
          secondLevelNodes,
          propsSelectedPurposes.value,
          purposesNodes.value,
          selectedTagsPurposes.value,
          excludedTagsPurposes.value
        );

        setSelectedNodes(
          thirdLevelNodes,
          propsSelectedAudience.value,
          audienceNodes.value,
          selectedTagsAudience.value,
          excludedTagsAudience.value
        );
      },
      { immediate: true, deep: true }
    );

    watch(
      propsSelectedLocations,
      () => {
        selectedTagsLocations.value = [];
        excludedTagsLocations.value = [];
        var rootNodes = getRootNodes(locationsNodes.value);
        var firstLevelNodes = getFirstLevelNodes(locationsNodes.value);
        var secondLevelNodes = getChildNodes(firstLevelNodes);
        var thirdLevelNodes = getChildNodes(secondLevelNodes);
        var selectedRootTags = rootNodes.filter(({ id: id1 }) =>
          propsSelectedLocations.value.some(({ id: id2 }) => id2 === id1)
        );
        selectedTagsLocations.value.push(...selectedRootTags);

        setFirstLevelSelectedNodes(
          firstLevelNodes,
          propsSelectedLocations.value,
          selectedTagsLocations.value,
          excludedTagsLocations.value
        );

        setSelectedNodes(
          secondLevelNodes,
          propsSelectedLocations.value,
          locationsNodes.value,
          selectedTagsLocations.value,
          excludedTagsLocations.value
        );

        setSelectedNodes(
          thirdLevelNodes,
          propsSelectedLocations.value,
          locationsNodes.value,
          selectedTagsLocations.value,
          excludedTagsLocations.value
        );
      },
      { immediate: true, deep: true }
    );

    watch(
      propsSelectedSchemeTypes,
      () => {
        selectedTagsSchemeTypes.value = [];
        excludedTagsSchemeTypes.value = [];
        var rootNodes = getRootNodes(schemeTypesNodes.value);
        var firstLevelNodes = getFirstLevelNodes(schemeTypesNodes.value);
        var secondLevelNodes = getChildNodes(firstLevelNodes);
        var thirdLevelNodes = getChildNodes(secondLevelNodes);
        var selectedRootTags = rootNodes.filter(({ id: id1 }) =>
          propsSelectedSchemeTypes.value.some(({ id: id2 }) => id2 === id1)
        );

        selectedTagsSchemeTypes.value.push(...selectedRootTags);

        setFirstLevelSelectedNodes(
          firstLevelNodes,
          propsSelectedSchemeTypes.value,
          selectedTagsSchemeTypes.value,
          excludedTagsSchemeTypes.value
        );

        setSelectedNodes(
          secondLevelNodes,
          propsSelectedSchemeTypes.value,
          schemeTypesNodes.value,
          selectedTagsSchemeTypes.value,
          excludedTagsSchemeTypes.value
        );

        setSelectedNodes(
          thirdLevelNodes,
          propsSelectedAudience.value,
          audienceNodes.value,
          selectedTagsAudience.value,
          excludedTagsAudience.value
        );
      },
      { immediate: true, deep: true }
    );

    watch(
      propsSelectedIndustriesNew,
      () => {
        selectedTagsIndustriesNew.value = [];
        excludedTagsIndustriesNew.value = [];

        var rootNodes = getRootNodes(industriesNewNodes.value);
        var firstLevelNodes = getFirstLevelNodes(industriesNewNodes.value);
        var secondLevelNodes = getChildNodes(firstLevelNodes);
        var thirdLevelNodes = getChildNodes(secondLevelNodes);
        var selectedRootTags = rootNodes.filter(({ id: id1 }) =>
          propsSelectedIndustriesNew.value.some(({ id: id2 }) => id2 === id1)
        );

        selectedTagsIndustriesNew.value.push(...selectedRootTags);

        setFirstLevelSelectedNodes(
          firstLevelNodes,
          propsSelectedIndustriesNew.value,
          selectedTagsIndustriesNew.value,
          excludedTagsIndustriesNew.value
        );

        setSelectedNodes(
          secondLevelNodes,
          propsSelectedIndustriesNew.value,
          industriesNewNodes.value,
          selectedTagsIndustriesNew.value,
          excludedTagsIndustriesNew.value
        );

        setSelectedNodes(
          thirdLevelNodes,
          propsSelectedAudience.value,
          audienceNodes.value,
          selectedTagsAudience.value,
          excludedTagsAudience.value
        );
      },
      { immediate: true, deep: true }
    );

    watch(
      propsSelectedProjectTypes,
      () => {
        selectedTagsProjectTypes.value = [];
        excludedTagsProjectTypes.value = [];
        var rootNodes = getRootNodes(projectTypesNodes.value);
        var firstLevelNodes = getFirstLevelNodes(projectTypesNodes.value);
        var secondLevelNodes = getChildNodes(firstLevelNodes);
        var selectedRootTags = rootNodes.filter(({ id: id1 }) =>
          propsSelectedProjectTypes.value.some(({ id: id2 }) => id2 === id1)
        );
        selectedTagsProjectTypes.value.push(...selectedRootTags);

        setFirstLevelSelectedNodes(
          firstLevelNodes,
          propsSelectedProjectTypes.value,
          selectedTagsProjectTypes.value,
          excludedTagsProjectTypes.value
        );

        setSelectedNodes(
          secondLevelNodes,
          propsSelectedProjectTypes.value,
          projectTypesNodes.value,
          selectedTagsProjectTypes.value,
          excludedTagsProjectTypes.value
        );
      },
      { immediate: true, deep: true }
    );

    return {
      propsSelectedAudience,
      propsSelectedPurposes,
      propsSelectedLocations,
      propsSelectedSchemeTypes,
      propsSelectedProjectTypes,
      propsSelectedIndustriesNew,
      propsSelectedKeywords,
      showSelectTags,
      enableShowSelectTags,
      audienceNodes,
      locationsNodes,
      purposesNodes,
      schemeTypesNodes,
      projectTypesNodes,
      industriesNewNodes,
      allKeywordsTags,
      filterOptions,
      selectedTagsAudience,
      tab,
      excludedTagsAudience,
      selectedTagsPurposes,
      excludedTagsPurposes,
      selectedTagsIndustriesNew,
      excludedTagsIndustriesNew,
      selectedTagsLocations,
      excludedTagsLocations,
      selectedTagsSchemeTypes,
      excludedTagsSchemeTypes,
      selectedTagsProjectTypes,
      excludedTagsProjectTypes,
      propsSelectedGroups,
      createValue(val, done) {
        if (val.length > 0) {
          if (!allKeywordsTags.value.includes(val)) {
            store.commit("tagsNavigation/updateAllKeywordsTags", val);
          }
          done(val, "add-unique");
        }
      },
      filterFn(val, update) {
        update(() => {
          if (val === "") {
            filterOptions.value = allKeywordsTags.value;
          } else {
            const needle = val.toLowerCase();
            filterOptions.value = allKeywordsTags.value.filter(
              v => v.toLowerCase().indexOf(needle) > -1
            );
          }
        });
      }
    };
  }
};
</script>
